/* eslint-disable no-empty-function */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useMemo, useState } from 'react'
import AuthService from '../services/auth.service'
import AuthContext from '../context'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getUser, idnAPIURL } from '@src/redux/actions/auth.actions'
import { Routes } from '@src/constants/routes'
import Spinner from '@src/components/common/loader'
import { InfoResponse, ENABLE_SSO, getOauthInfo } from '@src/endpoints/oauth'
import type { State } from '@src/redux/configureStore'
import { setStatusSSO } from '@src/redux/actions/shell.actions'
import { isEmpty } from 'lodash'
import StorageListener from '@src/utils/storage.helpers/tab.event'
import { TenantMgr } from '@src/endpoints/services/tenantMgr.service'
export * from './secure.route'

export interface SecurityProps {}

interface SecurityBodyProps {
  useSSO: boolean
  oauthOptions: InfoResponse
}

const enabledSSO = (state: State) => state.shell.enabledSSO

export const Security: React.FC<SecurityProps> = (
  props: React.PropsWithChildren<SecurityProps>
) => {
  const { children } = props
  const [oauthOptions, setOAuthOptions] = useState<InfoResponse>({})
  const useSSO = useSelector(enabledSSO)
  const dispatch = useDispatch()

  useEffect(() => {
    StorageListener()
    if (ENABLE_SSO) {
      TenantMgr.GetAuthInfo({
        params: {},
        options: {}
      })
        .then((res: any) => {
          dispatch(idnAPIURL(res?.idn_api_url))
          return getOauthInfo(res)
        })
        .then(res => {
          setOAuthOptions(res)
        })
        .catch(ex => {
          console.error('SSO is enabled but request failed')
          dispatch(setStatusSSO(false))
        })
    }
  }, [])

  const mount = !useSSO || !isEmpty(oauthOptions)

  return (
    <>
      {ENABLE_SSO && <Spinner loading={!mount} />}
      {mount && (
        <SecurityBody useSSO={useSSO} oauthOptions={oauthOptions}>
          {children}
        </SecurityBody>
      )}
    </>
  )
}

export const SecurityBody: React.FC<SecurityBodyProps> = (
  props: React.PropsWithChildren<SecurityBodyProps>
) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const initialAuthService = useMemo(
    () =>
      new AuthService({
        dispatch,
        oauthOptions: props.oauthOptions,
        onSuccess: (data, callback) => {
          dispatch(
            getUser(data?.user_name, callback, err => {
              history.push({
                pathname: Routes.loginPage,
                search: window.location.search
              })
            })
          )
        }
      }),
    [props]
  )

  initialAuthService.handleAuthentication(history)

  useEffect(() => {
    const { isAuthenticated, pending } = initialAuthService
    if (!isAuthenticated() && !pending?.handleAuthentication) {
      history.push({
        pathname: Routes.loginPage,
        search: window.location.search
      })
    }
  }, [])

  return (
    <AuthContext.Provider value={initialAuthService}>
      {props.children}
    </AuthContext.Provider>
  )
}
